import React, { useState, useEffect } from "react";
import classes from "./searchaccom.module.scss";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import AdminControlsDataGrid from "../../AdminControlsDataGrid";
import { EmployeeDetailView } from "./EmployeeDetailView";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { MockDataService } from "../../../../Service/MockDataService";
import {
  DataGridPro,
} from "@mui/x-data-grid-pro";
import axios from "axios";
import { constants } from "../../../../Shared/Url/Constants"; 
import Cookie from "js-cookie";
import moment from 'moment';
import { useSelector } from "react-redux";
import { isEmpty, toUpperCaseString } from "../../../../Shared/Utill/Utills";
import { Dialog, useToggle } from '@genesis/ui-kit';

const SearchAccommodation = (props) => {
  const token = Cookie.get('X_TKN');
  const urlDetails = useSelector((state) => state.url.urlData);

  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const [employeeID, setEmployeeID] = useState(null);
  const [searchValue, setSearchValue] = useState([]);
  const [isEmpIdValid, setEmpIdValid] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const dialog = useToggle();
  const [deleteDetails,setDeleteDetails] = useState({});
  const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
  const history = useNavigate();
  const accomRedirect = useLocation();

  useEffect(() => {
    if(accomRedirect.state !== null && accomRedirect.state.deleteAccomodation === "DeleteAccommodation"){
      setAlertOpen({
        open: true,
        severity: "success",
        message : "Acommodation deleted successfully."
    })
    setEmployeeID(accomRedirect.state.empId);
    getSearchResult(accomRedirect.state.empId);
    }
  }, []);

  const getReasonFromId = (Id) => {
    if(Id == 1){
      return "Medical";
    }else if(Id == 2){
      return "Religious";
    }else{
      return "Other";
    };
  }

  const onButtonClick = (e, id, method) => {
    e.stopPropagation();
    dialog.show();
    let data ={
      accomId: id,
      lastUpdatedBy: personStaticDetails.emplID,
      method: method
    }
    setDeleteDetails(data);    
  };

  const deleteAccomodation = () => {
    let data = {
      accomId: deleteDetails.accomId,
      lastUpdatedBy: deleteDetails.lastUpdatedBy
     } 
     axios.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_ADMIN_DELETE_WFM_ACCOMODATIONS}`, 
   data,
    {
      headers:{
      'Content-Type': 'application/json',
      'Authorization':'Bearer ' + token,
      }
    }).then((res) => {
      setAlertOpen({
        open: true,
        severity: "success",
        message : "Acommodation deleted successfully.",
      })
      
      dialog.hide();
      handleSearch();
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        setAlertOpen({
          open: true,
          severity: "error",
          message : err.response.data.message,
        })        
        dialog.hide();
      }
    });  
  }
  

  const getSearchResult = (associateId) => {
    //  MockDataService.
    //  getAccomSearch().
    //  then((res) => {
    //   setSearchValue(res);
    // });

    let url = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_SEARCH_ACCOMODATIONS_BY_ASSOCIATE}/${associateId}`;
    
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        console.log(res);
        setEmpIdValid(true);
        setEmployeeDetails(res.data.person);
        let tmparr = [];
        // Set states for all fields
        res.data.accommodations.map(obj => {
          let tmpobj = {}
          tmpobj.id = obj.accomId;
          tmpobj.approved_date = moment(obj.approvedDate).format('MMM DD, YYYY');;
          tmpobj.start_date = moment(obj.startDate).format('MMM DD, YYYY');
          tmpobj.end_date = !isEmpty(obj.endDate) ? moment(obj.endDate).format('MMM DD, YYYY') : "";
          tmpobj.reason = getReasonFromId(obj.accomTypeId);
          tmpobj.method = obj.accomMethod;
          tmpobj.updated_by = obj.lastUpdatedBy
          tmpobj.updated_date = moment(obj.lastUpdate).format('MMM DD, YYYY');
          tmpobj.create_date = moment(obj.createDate).format('MMM DD, YYYY');
          tmpobj.comments = obj.detail;
          if(obj.deleted == 0){
            tmparr.push(tmpobj);
          }
       });
       setSearchValue(tmparr);
      })
      .catch((err) => {
        setEmpIdValid(false);
        setAlertOpen({
          open: true,
          severity: "error",
          message: err.response.data.message,
        });
      });

  }
  //DataGrid columns
  const columns = [
    { field: "approved_date", headerName: "Approved", width: "120" },
    { field: "start_date", headerName: "Start Date", width: "120" },
    { field: "end_date", headerName: "End Date", width: "120" },
    { field: "reason", headerName: "Reason", width: "90" },
    { field: "method", headerName: "Method", width: "100" },
    { field: "updated_by", headerName: "Updated By", width: "130" },
    { field: "updated_date", headerName: "Updated Date", width: "125" },
    { field: "create_date", headerName: "Create Date", width: "125" },
    { field: "comments", headerName: "Comments", width: "210"
    },

    {
      field: "actions",
      headerName: "Actions",
      width: "140",
      renderCell: (params) => {
        //console.log("edit accom ", params.row.id);
        let delColor = false ? "gray2" : "gray";
        return (
          <Box sx={{ display: "flex", gap: "25px" }}>
            <NavLink
              to="Edit"
              style={{ textDecoration: "underline" }}
              state={{ flag: "E", accomId: params.row.id, details:employeeDetails }}
              className={classes.label_text}
            >
              <EditOutlinedIcon color={delColor}/>
            </NavLink>
            <DeleteOutlineIcon onClick={(e) => onButtonClick(e, params.row.id, params.row.method)}  />
          </Box>
        );
      },
    },
  ];

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };
  const handleSearch = () => {
    if (employeeID == null || employeeID == "") {
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please enter Employee ID",
      });
      return;
    }
    getSearchResult(employeeID);

  };

  return (
    <div className={classes.pagemargin}>
      <div className={classes.pagetitle}>Accommodations</div>
      <div className={classes.searchbox}>
        {/* Search view */}
        <Grid container spacing={3}>
          <Grid key={0} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Employee ID *"
                onChange={(e) => setEmployeeID(e.target.value)}
                value={employeeID}
                type="number"
              />
            </FormControl>
          </Grid>

          <Grid key={2} item xs={2}>
            <Button
              style={{
                marginLeft: "10px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px",
              }}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>

        <Dialog
        open={dialog.open}
        title='Confirm Delete'
        onClose={dialog.hide}
        actions={
          <>
            <Button color="secondary" onClick={dialog.hide}>No</Button>
            <Button onClick={deleteAccomodation}>Yes</Button>
          </>
        }
      >
        {toUpperCaseString(deleteDetails.method) === "SRS" ?
        <Typography>Deleting this accommodation will only remove from tracker, manual actions will need to be taken to remove from Kronos. Are you sure you want to delete this accommodation?</Typography>:
        <Typography>Are you sure you want to delete this accommodation?</Typography>
        }
      </Dialog>
        {employeeDetails && <Box>
        {/* Employee Details view */}
        <Typography sx={{ marginTop: "20px" }} variant="bodyLg">
          Employee Details
        </Typography>
        <EmployeeDetailView details={employeeDetails}/>
        <div className={classes.icon_text_wrap}>
          <div className={classes.icon_text}>
            <AddPlusIcon />
            <NavLink
              to={"Addaccomodation"}
              style={{ textDecoration: "underline" }}
              state={{ flag: "A", employeeID: employeeID, details:employeeDetails }}
              className={classes.label_text}
            >
              Add Accommodation
            </NavLink>
          </div>
        </div>

        {/* SeaAccomodation DataGrid */}
        <Typography sx={{ marginTop: "5px", alignContent: 'left' }} variant="bodyLg">
        {searchValue.length} Results Found
        </Typography>
        <Box sx={{ marginTop: "10px" ,height:  400, width: "100%" }} >
        
        <DataGridPro
          columns={columns}
          rows={searchValue}
          autoPageSize={true}
          hideFooter={true}
        />
        </Box>
      </Box>}
        {/* snackbar */}
        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>
      </div>
    </div>
  );
};

export default SearchAccommodation;
